import React from 'react';
import { CheckCircle } from 'react-feather';
import classNames from 'classnames';
import { isEmpty } from 'lodash';
import SessionDetails from 'components/InPersonTraining/shared/SessionDetails';
import moment, { ISO_8601, now } from 'moment';

const SessionListing = ({
  sessions,
  selectedSessionId,
  handleSessionClick,
  hasMultipleSessions,
  attendance,
  currentSession,
  event,
  changingAttendance,
  previewing,
  canChangeAttendance,
  pastEvent,
}) => {
  const showMultiSessionListing =
    hasMultipleSessions &&
    (previewing ||
      changingAttendance ||
      isEmpty(attendance) ||
      (attendance.rsvp_status === null && attendance.did_attend === null) ||
      attendance.session_id === null);
  const showMultiSessionDetail =
    hasMultipleSessions &&
    !previewing &&
    !changingAttendance &&
    !isEmpty(attendance) &&
    attendance.session_id !== null &&
    (attendance.rsvp_status !== null || attendance.did_attend !== null);
  const disableSessionButtons =
    previewing ||
    (attendance.rsvp_status === 'will_not_attend' &&
      changingAttendance === false);
  const disableMeetingLink = !canChangeAttendance && pastEvent;
  return (
    <>
      {!hasMultipleSessions && (
        <>
          <SessionDetails
            session={currentSession || sessions[0]}
            eventId={event.id}
            showRegistrationCap
            hasMultipleSessions={hasMultipleSessions}
            previewing={previewing}
            disableMeetingLink={disableMeetingLink}
          />
        </>
      )}
      {showMultiSessionDetail && (
        <SessionDetails
          session={currentSession}
          eventId={event.id}
          showRegistrationCap
          hasMultipleSessions={false}
          previewing={previewing}
          disableMeetingLink={disableMeetingLink}
          showSessionName
        />
      )}
      {showMultiSessionListing &&
        sessions.map(session => {
          const disablePastSession =
            moment(session.start_time, ISO_8601).isBefore(now()) &&
            !canChangeAttendance;

          return (
            <button
              className={classNames('EventSessionListing pos-r py-16 px-24', {
                'EventSessionListing--selected':
                  session.id === selectedSessionId,
              })}
              onClick={() => handleSessionClick(session.id)}
              key={session.id}
              type="button"
              disabled={
                session.type?.at_capacity ||
                disablePastSession ||
                disableSessionButtons
              }
            >
              <SessionDetails
                session={session}
                eventId={session.event_id}
                showRegistrationCap
                hasMultipleSessions={hasMultipleSessions}
                previewing={
                  previewing ||
                  disableSessionButtons ||
                  disablePastSession ||
                  session.type?.at_capacity
                }
                disableMeetingLink={disableMeetingLink}
                showSessionName
              />
              {session.id === selectedSessionId && (
                <CheckCircle
                  label="Selected Session"
                  size={16}
                  className="EventSessionListing-icon c-midnight-100"
                />
              )}
            </button>
          );
        })}
    </>
  );
};

export default SessionListing;
